{
  "version": 1,
  "asset_id": "6e96143b-1b2d-4158-84ef-22bafaf715f5",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/6e96143b-1b2d-4158-84ef-22bafaf715f5/silivri-hizli-elektrikci-7-24-dukkan-4.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/6e96143b-1b2d-4158-84ef-22bafaf715f5/silivri-hizli-elektrikci-7-24-dukkan-4.jpg",
  "original_filename": "silivri-hizli-elektrikci-7-24-dukkan-4.jpg",
  "size": 133941,
  "content_type": "image/jpeg",
  "created_at": "2026-09-20T08:26:45Z"
}
